import React from 'react';
import {
  Box,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import { BudgetControlModel } from './budgetcontrol.models';

type Props = {
  model: BudgetControlModel;
};

const money = (value: number, currency: string): string =>
  new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: currency || 'XOF',
    maximumFractionDigits: 0,
  }).format(value || 0);

class SummaryCard extends React.PureComponent<{
  label: string;
  value: string;
  detail?: string;
}> {
  render() {
    return (
      <Paper variant="outlined" sx={{ p: 2, minWidth: 210, flex: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {this.props.label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {this.props.value}
        </Typography>
        {this.props.detail && (
          <Typography variant="caption" color="text.secondary">
            {this.props.detail}
          </Typography>
        )}
      </Paper>
    );
  }
}

export default class BudgetControlSummary extends React.PureComponent<Props> {
  render() {
    const m = this.props.model;

    return (
      <Stack spacing={1.5}>
        <Stack direction={{ xs: 'column', lg: 'row' }} spacing={1.5}>
          <SummaryCard
            label="Approved budget capacity"
            value={money(m.capacityamount, m.currencycode)}
            detail={m.sourcescenarioid ? `Source scenario #${m.sourcescenarioid}` : 'Approved planning assumption'}
          />
          <SummaryCard
            label="Distributed capacity"
            value={money(m.allocatedcapacity, m.currencycode)}
            detail={`${m.allocatedpercent.toFixed(2)}% assigned`}
          />
          <SummaryCard
            label="Unallocated buffer"
            value={money(m.bufferamount, m.currencycode)}
            detail={`${m.bufferpercent.toFixed(2)}% retained`}
          />
          <SummaryCard
            label="Control version"
            value={`Version ${m.versionno}`}
            detail={m.iscurrent ? 'Current governing envelope' : 'Not current'}
          />
        </Stack>

        <Box>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="caption">Capacity distribution</Typography>
            <Typography variant="caption">
              {m.allocatedpercent.toFixed(2)}%
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={Math.min(Math.max(m.allocatedpercent, 0), 100)}
            sx={{ height: 8, borderRadius: 4 }}
          />
        </Box>
      </Stack>
    );
  }
}
